import React, { Component } from 'react'
import Context from '../models/Context'

class LanguageSelector extends Component {
  constructor(props) {
    super(props)
    
    this.state = {
      locale: ''
    }
    
    this.onLocaleChange = this.onLocaleChange.bind(this)
  }

  componentDidMount() {
    const { translationService } = this.context
    const locale = translationService.getLocale()
    this.setState({ locale })
  }

  onLocaleChange(e) {
    const { target } = e
    const { value: locale } = target
    const { translationService } = this.context

    translationService.setLocale(locale)
    translationService.saveLocale()

    this.setState({ locale })
    window.location.reload()
  }

  render() {
    const { t, translationService } = this.context
    const locales = translationService.getLocales()
    const { className = '' } = this.props

    return (
      <div className={`language-selector ${className}`}>
        <select 
          value={this.state.locale} 
          onChange={this.onLocaleChange}
          className="language-selector__dropdown bg-transparent border-none text-gray cursor-pointer focus:outline-none"
          title="Language / Sprache"
        >
          {locales.map((locale, i) => (
            <option value={locale} key={`locale-${i}`}>
              {t(`LOCALES.${locale}`)}
            </option>
          ))}
        </select>
      </div>
    )
  }
}

LanguageSelector.contextType = Context

export default LanguageSelector
